<script lang="ts">
// import Router from 'svelte-spa-router'
import { Router, Link, Route } from "svelte-routing";
import PageNotFound from "./routes/PageNotFound.svelte";
import PageForm from "./routes/PageForm.svelte";

export let url = ''
</script>

<!-- <Router {routes}/> -->
<Router url="{url}">
	<!-- <Route path="/" component="{PageHome}" /> -->
	<Route path="/" component="{PageForm}" />
	<Route path="/*" component="{PageNotFound}" />
</Router>

<style lang="scss">
</style>
